import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'

const SvgUnderline01 = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M18 4v7a6 6 0 0 1-12 0V4M4 21h16"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgUnderline01)
export default ForwardRef
